// refundListSlice.js
import { createEntityAdapter, createSelector } from "@reduxjs/toolkit";
import { apiSlice } from "../apiSlice";


const refundListAdapter = createEntityAdapter({
  selectId: (refund) => refund.id,
});

const initialState = refundListAdapter.getInitialState();

export const refundListSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getRefundList: builder.query({
      query: (filters = {}) => {
        const params = [];
        if (filters.status) params.push(`status=${filters.status}`);
        if (filters.search)
          params.push(`search=${encodeURIComponent(filters.search)}`);

        return params.length
          ? `refunds?${params.join("&")}`
          : "refunds";
      },

      transformResponse: (responseData) => {
        const loadedRefunds = responseData.data.map((r) => ({ ...r }));

        return refundListAdapter.setAll(initialState, loadedRefunds);
      },

      providesTags: (result) =>
        result
          ? [
              { type: "refund", id: "refundList" },
              ...result.ids.map((id) => ({ type: "refund", id })),
            ]
          : [{ type: "refund", id: "refundList" }],
    }),

    getRefundById: builder.query({
      query: (refundId) => `refunds/${refundId}`,
      transformResponse: (responseData) => responseData.data,
      providesTags: (result, error, refundId) => [
        { type: "refund", id: refundId },
      ],
    }),
  }),
});

export const {
  useGetRefundListQuery,
  useGetRefundByIdQuery,
} = refundListSlice;

/* -------- FILTER & SELECTORS -------- */

const refundFilter = (state) => state.refundFilter;

const selectRefundListResult = createSelector(
  [refundFilter, (state) => state],
  (filter, state) =>
    refundListSlice.endpoints.getRefundList.select({
      status: filter.status,
      search: filter.search,
    })(state)
);

const selectRefundListData = createSelector(
  [selectRefundListResult],
  (result) => result?.data ?? initialState
);

export const {
  selectAll: selectRefunds,
  selectById: selectRefundById,
  selectIds: selectRefundIds,
} = refundListAdapter.getSelectors((state) =>
  selectRefundListData(state)
);
